import { Component, OnInit,ViewChild } from '@angular/core';
import { BankAccountsService} from 'app/shared/services/bank-accounts.service';
import { AuthService } from 'app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { MatDialogConfig } from '@angular/material/dialog';
import { BankAccountsComponent } from '../bank-account/bank-accounts.component';
import { NbThemeService } from '@nebular/theme';


@Component({
  selector: 'ngx-bank-account-list',
  templateUrl: './bank-account-list.component.html',
  styleUrls: ['./bank-account-list.component.scss']
})
export class BankAccountListComponent implements OnInit {

  
  displayedColumns: string[] = ['accountName','bank','accountNo','currentBal','createdBy','action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  isDark: boolean = false;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  data : any[]; 
  
  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };

  constructor(
    private bankAccountsService:BankAccountsService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    private authService: AuthService,
    private themeService: NbThemeService,
    private router : Router, 
  ) { }

  ngOnInit(): void {

    this.getBankAccountList();
    this.getControlPermissions();
    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
     
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='MACC'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }

  newButtonClick(){
    this.bankAccountsService.dataRow = null;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "50%";
    this.dialogService.openDialog(BankAccountsComponent,dialogConfig)
    .afterClosed().subscribe(res => this.getBankAccountList());  
   }

   veiwButtonClick(row){
    this.bankAccountsService.dataRow = row;  
    const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "50%";
     this.dialogService.openDialog(BankAccountsComponent,dialogConfig)
      .afterClosed().subscribe(res => this.getBankAccountList());

  }


  getBankAccountList(){
    this.bankAccountsService.getAllBankAccounts()
     .subscribe(
        (data) => {
                  this.data = data;
                  this.dataSource = new  MatTableDataSource (this.data);  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }


     deleteButtonClick(id : number){
      this.dialogService.openConfirmDialog('Are you sure you want to delete this record?')
      .afterClosed().subscribe(res =>{
        if(res){
          this.bankAccountsService.deleteBankAccount(id)
        .subscribe(
          (res) => {
                      this.toastr.success('deleted successfully','Success');
                      this.getBankAccountList();
                      console.log(res);     
                    },        
          (err) =>  {
                      this.toastr.error('Failed to delete record','Failure');
                      if(err instanceof HttpErrorResponse){                 
                        if(err.status == 401){
                          this.router.navigate(['/login']);
                        }
                      }
                      console.log(err);
                    }, 
            )
        }
      });            
  }

  applyFilter(){
    this.dataSource.filter =this.searchKey.trim().toLowerCase();

  }
  
  onSearchClear(){
    this.searchKey = "";
    this.applyFilter();
  }


}
